import type { NoteContent } from "../../api/workspace-notes.api";
import { InlineComposer } from "./ReferenceComposer";
import {
  makeToken,
  type InlineReference,
} from "../messaging/inline-references";
import { useReferenceResolution } from "./ReferenceList";
import { useAuthStore } from "../../store/auth.store";
export const noteReferenceToken = (r: {
  entityType: string;
  entityId: string;
}) => `#[${r.entityType}:${r.entityId}]`;
export function NoteComposer({
  draft,
  onChange,
  disabled = false,
  label = "Contenu",
  maxReferences = 20,
  maxLength = 20000,
}: {
  draft: NoteContent;
  onChange: (next: NoteContent) => void;
  disabled?: boolean;
  label?: string;
  maxReferences?: number;
  maxLength?: number;
}) {
  const school = useAuthStore((s) => s.activeSchoolId),
    user = useAuthStore((s) => s.user?.id);
  const references = draft.references ?? [];
  const resolved = useReferenceResolution(references);
  const bindings: InlineReference[] = [];
  let text = draft.body;
  references.forEach((r, i) => {
    const stored = noteReferenceToken(r);
    if (!text.includes(stored)) return;
    const item = resolved.items?.[i];
    const token = makeToken(
      item?.available ? item.label : "Objet Permio",
      bindings,
    );
    bindings.push({ ...r, token });
    text = text.split(stored).join(token);
  });
  return (
    <InlineComposer
      text={text}
      refs={bindings}
      scope={[school ?? "", user ?? ""]}
      disabled={disabled}
      maxReferences={maxReferences}
      maxLength={maxLength}
      label={label}
      submitOnEnter={false}
      onChange={(value, refs) => {
        let body = value;
        for (const ref of refs)
          body = body.split(ref.token).join(noteReferenceToken(ref));
        const next = [...references];
        for (const { entityType, entityId } of refs)
          if (
            !next.some(
              (r) => r.entityType === entityType && r.entityId === entityId,
            )
          )
            next.push({ entityType, entityId });
        if (next.length <= maxReferences && body.length <= maxLength)
          onChange({ ...draft, body, references: next });
      }}
    />
  );
}
